/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPolicyResourceRecommendationRemoval extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPolicyResourceRecommendationRemoval");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPolicyResourceRecommendationRemoval.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPolicyResourceRecommendationRemoval>): BackgroundJobPayloadForPolicyResourceRecommendationRemoval {
        let obj = Object.assign(new BackgroundJobPayloadForPolicyResourceRecommendationRemoval(), model);
        BackgroundJobPayloadForPolicyResourceRecommendationRemoval.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPolicyResourceRecommendationRemoval>): BackgroundJobPayloadForPolicyResourceRecommendationRemoval {
        if (!model) return null;
        return BackgroundJobPayloadForPolicyResourceRecommendationRemoval.newInstance(<BackgroundJobPayloadForPolicyResourceRecommendationRemoval> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPolicyResourceRecommendationRemoval) {
        if (!obj) return;

        models.BackgroundJobPayloadForPolicyResourceRecommendationRemoval.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPolicyResourceRecommendationRemoval): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPolicyResourceRecommendationRemoval.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Inventory IDs
     */
    inventory_ids: Array<string>;

}
